import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <footer className="bg-black text-white py-16 px-6 md:px-12 lg:px-24" data-id="element-587">
      <div className="max-w-7xl mx-auto" data-id="element-588">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-589">
          {/* Logo and Description */}
          <div className="md:col-span-1" data-id="element-590">
            <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8 mb-4 brightness-0 invert" data-id="element-591" />
            <p className="text-sm text-gray-400 leading-relaxed" data-id="element-592">
              The Contextual Intelligence Company.
            </p>
          </div>

          {/* Solutions - FIXED ORDER TO MATCH NAVIGATION */}
          <div data-id="element-593">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-594">
              Solutions
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-595">
              <li data-id="element-596">
                <Link to="/the-instruction-layer" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-597">
                  The Instruction Layer
                </Link>
              </li>
              <li data-id="element-598">
                <Link to="/context-engineering" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-599">
                  Context Engineering
                </Link>
              </li>
              <li data-id="element-600">
                <Link to="/how-it-works" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-601">
                  How It Works
                </Link>
              </li>
              <li data-id="element-602">
                <Link to="/agent-drift" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-603">
                  Agent Constitution
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-604">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-605">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-606">
              <li data-id="element-607">
                <Link to="/about" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-608">
                  About Synthia
                </Link>
              </li>
              <li data-id="element-609">
                <Link to="/blog" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-610">
                  Blog
                </Link>
              </li>
              <li data-id="element-611">
                <Link to="/contact" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-612">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-613">
                <Link to="/support" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-614">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-615">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-616">
              Legal
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-617">
              <li data-id="element-618">
                <Link to="/terms" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-619">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-620">
                <Link to="/privacy" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-621">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-622">
          <p className="text-sm text-gray-500" data-id="element-623">
            © 2026 meetsynthia.ai, Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-624">
            <a href="https://www.linkedin.com/company/meetsynthia-ai/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-625">
              LinkedIn
            </a>
            <a href="https://x.com/meetsynthiaAI" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-626">
              X
            </a>
          </div>
        </div>
      </div>
    </footer>;
}